import { ReferenceCrud } from "@/components/admin/ReferenceCrud";
import { titleCase } from "@/lib/format";

const FIELDS = [
  { name: "name", label: "Category name", required: true, max: 80 },
  { name: "slug", label: "Slug", hint: "Leave empty to generate from the name", max: 80 },
  { name: "gender", label: "Audience", type: "select", required: true, default: "unisex", options: [{ value: "unisex", label: "All (Women, Men & Kids)" }, { value: "women", label: "Women only" }, { value: "men", label: "Men only" }, { value: "kids", label: "Kids only" }] },
  {
    name: "parent_id", label: "Parent category", type: "select", nullable: true, nonePlaceholder: "Top level", hint: "Two levels only; parent must share the department",
    options: (form, items) => (items || []).filter((c) => !c.parent_id && c.gender === form.gender && c.status === "active").map((c) => ({ value: c.id, label: c.name })),
  },
  { name: "display_order", label: "Display order", type: "number", default: 0, min: 0 },
  { name: "description", label: "Description", type: "textarea", rows: 3, span: 2, max: 2000 },
  { name: "seo_title", label: "SEO title", max: 70 },
  { name: "seo_description", label: "SEO description", max: 170 },
];

const COLUMNS = [
  { key: "name", label: "Category", render: (c) => <span>{c.parent_name ? <span className="text-muted-foreground font-normal">{c.parent_name} / </span> : null}{c.name}</span> },
  { key: "gender", label: "Department", render: (c) => titleCase(c.gender) },
  { key: "slug", label: "Slug", render: (c) => <span className="text-muted-foreground font-mono text-xs">{c.slug}</span> },
  { key: "display_order", label: "Order", className: "text-right tabular" },
  { key: "product_count", label: "Products", className: "text-right tabular", render: (c) => c.product_count ?? 0 },
];

export default function AdminCategories() {
  return <ReferenceCrud resource="categories" label="Category" labelPlural="Categories" eyebrow="Catalog" description="Department taxonomy that drives navigation and filtering. Up to two levels per department." fields={FIELDS} columns={COLUMNS} writePerm="catalog.write" pageSize={200} searchPlaceholder="Search categories…" />;
}
